import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/auth/authSlice';
import uiSlice from '../components/ui/uiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiSlice
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
